/* eslint-disable no-mixed-spaces-and-tabs */
/* eslint-disable react/jsx-wrap-multilines */
import React, { useEffect } from 'react';
import { createStructuredSelector } from 'reselect';
import { connect } from 'react-redux';
import { useHistory, useLocation } from 'react-router';
import { destroy, submit } from 'redux-form';
import PropTypes from 'prop-types';
import { useInjectSaga } from '../../utils/injectSaga';
import saga from './saga';
import { useInjectReducer } from '../../utils/injectReducer';
import reducer from './reducer';
import { FORM_NAME } from './constants';
import ModalFooterButtons from '../../semantic-ui/components/modal-window/modal-footer-buttons';
import { ModalWindow } from '../../semantic-ui/components/modal-window';
import {
	getActiveOrdersWaysIdSelector,
	getOrdersWaysInfoSelector,
	getOrdersWaysNameSelector,
	getIsOrdersWaysAddFormOpenSelector,
	getIsOrdersWaysEditFormOpenSelector,
	getIsOrdersWaysInfoLoadingSelector,
	getIsModalShownSelector,
	getIsAuditTabShownSelector,
	getIsOptionsLoadingSelector,
	getIsAvailableOrdersGroupsUpdateSelector,
	getIsOrdersWaysTrashedSelector,
} from './selectors';
import {
	createOrdersWaysAction,
	deleteOrdersWaysAction,
	getOrdersWaysInfoAction,
	resetStateAction,
	updateOrdersWaysAction,
	getGroupIdListAction,
} from './actions';
import { OrdersWaysContent } from './components/orders-ways-content';
import { removeModalQuery } from '../../utils/removeModalQuery';
import { getIsAvailableOrdersGroupsButtonsSelector } from '../profile/selectors';
import { setWindowInfoAction } from '../alert-modal/actions';
import { Audit } from '../../components/audit';
import closeModal from '../../utils/closeModal';
import cancelModal from '../../utils/cancelModal';

const OrdersWaysModalWrapper = ({
	onGetOrdersWaysInfo,
	isOrdersWaysInfoLoading,
	isOrdersWaysEditFormOpen,
	isOrdersWaysAddFormOpen,
	ordersWaysInfo,
	ordersWaysName,
	onResetState,
	onDeleteOrdersWays,
	isModalShown,
	activeOrdersWaysId,
	onUpdateOrdersWays,
	onGetGroupIdList,
	isAvailable,
	onFormSubmit,
	onSetWindowInfo,
	onResetForm,
	onCreateOrdersWays,
	isAuditTabShown,
	getIsOptionsLoadingSelector,
	isAvailableUpdate,
	isOrdersWaysTrashed,
}) => {
	if (!isModalShown) return null;
	useInjectSaga({ key: 'ordersWaysModalSaga', saga });
	useInjectReducer({ key: 'ordersWaysModalReducer', reducer });
	const { search, pathname } = useLocation();

	const query = new URLSearchParams(search);

	const history = useHistory();

	useEffect(() => {
		if (activeOrdersWaysId) {
			onGetOrdersWaysInfo(activeOrdersWaysId);
		}
	}, [activeOrdersWaysId, isOrdersWaysEditFormOpen, isOrdersWaysAddFormOpen]);

	useEffect(() => {
		if (isOrdersWaysEditFormOpen || isOrdersWaysAddFormOpen) {
			onGetGroupIdList();
		}
	}, [isOrdersWaysEditFormOpen, isOrdersWaysAddFormOpen]);

	const handleOrdersWaysFormOpenButtonClick = mode => {
		if (activeOrdersWaysId) {
			query.set('id', activeOrdersWaysId);
		} else {
			query.delete('id');
		}

		if (mode === 'edit') {
			query.set('mode', 'edit');
		}

		if (mode === 'cancel') {
			onResetForm(FORM_NAME);
			query.delete('mode');
		}

		if (mode === 'cancel' && !activeOrdersWaysId) {
			onResetState();
			onResetForm(FORM_NAME);
			query.delete('modal');
		}

		history.push(`${pathname}?${query}`);
	};

	const handleModalCancel = () => {
		cancelModal(query);

		onResetState();
		onResetForm(FORM_NAME);
		history.push(`${pathname}?${query}`);
	};

	const handleModalClose = () => {
		closeModal(query);

		onResetState();
		onResetForm(FORM_NAME);
		history.push(`${pathname}?${query}`);
	};

	const handleNavItemClick = tab => {
		if (tab === 'info') {
			query.delete('tab');
		}

		if (tab === 'audit') {
			query.set('tab', 'audit');
		}

		history.push(`${pathname}?${query}`);
	};

	const handleOrdersWaysDelete = () => {
		onSetWindowInfo({
			type: 'delete',
			title: 'Вы уверены?',
			text: 'Вы не сможете это отменить',
			button: {
				type: 'success',
				text: 'Да, удалить',
				onClick: () =>
					onDeleteOrdersWays({
						id: activeOrdersWaysId,
						redirect: handleModalClose,
						searchQuery: removeModalQuery(query.toString()),
						pathname,
					}),
			},
		});
	};

	const handleOrdersWaysFormSubmit = async () => {
		await onFormSubmit(FORM_NAME);

		if (activeOrdersWaysId) {
			onUpdateOrdersWays({
				id: activeOrdersWaysId,
				redirect: () => handleOrdersWaysFormOpenButtonClick('cancel'),
				searchQuery: removeModalQuery(query.toString()),
				pathname,
			});
			return;
		}

		onCreateOrdersWays({
			redirect: handleModalClose,
			resetState: () => {
				onResetState();
				onResetForm(FORM_NAME);
			},
			searchQuery: removeModalQuery(query.toString()),
		});
	};

	const handleKeyDown = e => {
		if (e.key === 'Enter' && e.shiftKey === false) {
			handleOrdersWaysFormSubmit();
		}
	};

	const filteredOrdersWaysInfo = ordersWaysInfo.filter(el => el.id !== 'id');

	return (
		<ModalWindow
			isModalShown={isModalShown}
			onKeyDown={handleKeyDown}
			onClose={handleModalClose}
			headerText={
				isOrdersWaysEditFormOpen || isOrdersWaysAddFormOpen
					? `${isOrdersWaysEditFormOpen ? 'Изменить маршрут' : 'Создать маршрут'}`
					: ordersWaysName
			}
			navItems={
				isOrdersWaysAddFormOpen || isOrdersWaysEditFormOpen
					? []
					: [
							{
								id: 'info',
								text: 'Информация',
								onClick: () => handleNavItemClick('info'),
								isActive: !isAuditTabShown,
							},
							{
								id: 'audit',
								text: 'Изменения',
								onClick: () => handleNavItemClick('audit'),
								isActive: isAuditTabShown,
							},
					  ]
			}
			modalContent={
				!isAuditTabShown ? (
					<OrdersWaysContent
						ordersWaysInfo={filteredOrdersWaysInfo}
						isOrdersWaysInfoLoading={isOrdersWaysInfoLoading}
						isOrdersWaysFormOpen={isOrdersWaysEditFormOpen || isOrdersWaysAddFormOpen}
					/>
				) : (
					<Audit entityName="orders_ways" entityId={activeOrdersWaysId} />
				)
			}
			style={{ width: '895px' }}
			actionButtons={[{ type: 'close', onClick: handleModalClose, text: 'orders_ways_modal' }]}
			footerButtons={
				<ModalFooterButtons
					leftButtons={
						!(isOrdersWaysEditFormOpen || isOrdersWaysAddFormOpen) &&
						isAvailable.delete &&
						!isAuditTabShown &&
						!isOrdersWaysTrashed
							? [
									{
										onClick: handleOrdersWaysDelete,
										text: 'Удалить',
										color: 'warning',
										disabled: isOrdersWaysInfoLoading,
									},
							  ]
							: []
					}
					rightButtons={
						isOrdersWaysEditFormOpen || isOrdersWaysAddFormOpen
							? [
									{
										onClick: handleOrdersWaysFormSubmit,
										text: 'Сохранить',
										color: 'primary',
										loading: isOrdersWaysInfoLoading,
										disabled: isOrdersWaysInfoLoading || getIsOptionsLoadingSelector,
									},
									{
										onClick: () => handleOrdersWaysFormOpenButtonClick('cancel'),
										text: 'Отмена',
										color: 'secondary',
										disabled: isOrdersWaysInfoLoading,
									},
							  ]
							: [
									...(isAvailable.update &&
									!isAuditTabShown &&
									isAvailableUpdate &&
									!isOrdersWaysTrashed
										? [
												{
													onClick: () => handleOrdersWaysFormOpenButtonClick('edit'),
													text: 'Изменить',
													color: 'primary',
													disabled: isOrdersWaysInfoLoading || getIsOptionsLoadingSelector,
												},
										  ]
										: []),
									{
										onClick: handleModalCancel,
										text: 'Закрыть',
										color: 'secondary',
									},
							  ]
					}
				/>
			}
		/>
	);
};

const mapStateToProps = createStructuredSelector({
	ordersWaysInfo: getOrdersWaysInfoSelector(),
	isOrdersWaysInfoLoading: getIsOrdersWaysInfoLoadingSelector(),
	isOrdersWaysAddFormOpen: getIsOrdersWaysAddFormOpenSelector(),
	isOrdersWaysEditFormOpen: getIsOrdersWaysEditFormOpenSelector(),
	ordersWaysName: getOrdersWaysNameSelector(),
	isModalShown: getIsModalShownSelector(),
	activeOrdersWaysId: getActiveOrdersWaysIdSelector(),
	isAvailable: getIsAvailableOrdersGroupsButtonsSelector(),
	isAvailableUpdate: getIsAvailableOrdersGroupsUpdateSelector(),
	isAuditTabShown: getIsAuditTabShownSelector(),
	getIsOptionsLoadingSelector: getIsOptionsLoadingSelector(),
	isOrdersWaysTrashed: getIsOrdersWaysTrashedSelector(),
});

const mapDispatchToProps = {
	onGetOrdersWaysInfo: getOrdersWaysInfoAction,
	onDeleteOrdersWays: deleteOrdersWaysAction,
	onResetState: resetStateAction,
	onCreateOrdersWays: createOrdersWaysAction,
	onUpdateOrdersWays: updateOrdersWaysAction,
	onGetGroupIdList: getGroupIdListAction,
	onFormSubmit: submit,
	onSetWindowInfo: setWindowInfoAction,
	onResetForm: destroy,
};

const OrdersWaysModal = connect(mapStateToProps, mapDispatchToProps)(OrdersWaysModalWrapper);

OrdersWaysModalWrapper.propTypes = {
	onGetOrdersWaysInfo: PropTypes.func.isRequired,
	ordersWaysInfo: PropTypes.arrayOf(
		PropTypes.shape({
			id: PropTypes.string.isRequired,
			title: PropTypes.string.isRequired,
			value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
		}),
	),
	isOrdersWaysInfoLoading: PropTypes.bool.isRequired,
	isOrdersWaysEditFormOpen: PropTypes.bool.isRequired,
	isOrdersWaysAddFormOpen: PropTypes.bool.isRequired,
	ordersWaysName: PropTypes.string.isRequired,
	onDeleteOrdersWays: PropTypes.func.isRequired,
	onResetState: PropTypes.func.isRequired,
	isModalShown: PropTypes.bool.isRequired,
	activeOrdersWaysId: PropTypes.string,
	onCreateOrdersWays: PropTypes.func.isRequired,
	onUpdateOrdersWays: PropTypes.func.isRequired,
	onGetGroupIdList: PropTypes.func.isRequired,
	isAvailable: PropTypes.objectOf(PropTypes.bool),
	onFormSubmit: PropTypes.func.isRequired,
	onSetWindowInfo: PropTypes.func.isRequired,
	onResetForm: PropTypes.func.isRequired,
	isAuditTabShown: PropTypes.bool.isRequired,
	isAvailableUpdate: PropTypes.bool.isRequired,
	getIsOptionsLoadingSelector: PropTypes.bool,
	isOrdersWaysTrashed: PropTypes.bool,
};

export default OrdersWaysModal;
